/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-betting-promo-card.get-names.ts 
*/
:host {
  box-sizing: border-box;
  display: block;
  height: 100%;
  max-width: 17.5rem;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  :host {
    max-width: 17.5rem;
  }
}
@media only screen and (min-width: 1025px) {
  :host {
    max-width: 17.5rem;
  }
}
:host * {
  box-sizing: border-box;
}
:host a {
  text-decoration: none;
}

a.ace-betting-promo-card {
  transition: 100ms linear;
}
a.ace-betting-promo-card:hover {
  box-shadow: var(--ace-elevation-level-2);
  transition: 100ms linear;
}

.ace-betting-promo-card {
  background-color: var(--ace-color-surface-solid--100);
  border-radius: var(--ace-semantic-foundation-radius-s);
  box-shadow: var(--ace-elevation-level-1);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
  max-height: 10rem;
}
.ace-betting-promo-card__image-container {
  aspect-ratio: 21/9;
  flex-shrink: 1;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.ace-betting-promo-card__image {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.ace-betting-promo-card__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 3.25rem;
  padding: var(--ace-primitive-spacing-x-tight) var(--ace-primitive-spacing-tight);
}
.ace-betting-promo-card__headline {
  color: var(--ace-color-text-neutral--primary);
  margin: 0;
  font-family: var(--ace-type-font-family-subheading);
  font-size: var(--ace-type-font-size-h5-mobile);
  font-weight: var(--ace-type-font-weight-subheading);
  letter-spacing: var(--ace-type-letter-spacing-h5-mobile);
  line-height: var(--ace-type-line-height-h5-mobile);
}
@media only screen and (min-width: 595px) {
  .ace-betting-promo-card__headline {
    font-size: var(--ace-type-font-size-h5-tablet);
    letter-spacing: var(--ace-type-letter-spacing-h5-tablet);
    line-height: var(--ace-type-line-height-h5-tablet);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-betting-promo-card__headline {
    font-size: var(--ace-type-font-size-h5-desktop);
    letter-spacing: var(--ace-type-letter-spacing-h5-desktop);
    line-height: var(--ace-type-line-height-h5-desktop);
  }
}
.ace-betting-promo-card__headline {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ace-betting-promo-card__body {
  color: var(--ace-color-text-neutral--secondary);
  margin: 0;
  font-size: var(--ace-type-font-size-text-x-small);
  letter-spacing: var(--ace-type-letter-spacing-text-x-small);
  line-height: var(--ace-type-line-height-text-x-small);
  font-family: var(--ace-type-font-family-text);
  font-weight: var(--ace-type-font-weight-button-subtle);
}
.ace-betting-promo-card__actions {
  display: none;
}
.ace-betting-promo-card__border {
  background-color: transparent;
  border: var(--ace-semantic-foundation-border-decorative) var(--ace-color-borders--100);
  border-radius: var(--ace-semantic-foundation-radius-s);
  bottom: 0;
  content: "";
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
}
.ace-betting-promo-card--sports-theme {
  background: var(--ace-color-brand-verticals--sports);
}
.ace-betting-promo-card--sports-theme .ace-betting-promo-card__headline {
  color: var(--ace-color-text-neutral--interactive-uni-light);
}
.ace-betting-promo-card--sports-theme .ace-betting-promo-card__body {
  color: var(--ace-color-text-neutral--secondary-uni-light);
}
@media only screen and (min-width: 595px) {
  .ace-betting-promo-card--full-width {
    align-items: center;
    flex-direction: row;
    gap: var(--ace-primitive-spacing-loose);
    padding: var(--ace-primitive-spacing-normal);
  }
  .ace-betting-promo-card--full-width .ace-betting-promo-card__image-container {
    border-radius: var(--ace-primitive-radius-x-small);
    flex: 1;
  }
  .ace-betting-promo-card--full-width .ace-betting-promo-card__content {
    flex: 1;
  }
  .ace-betting-promo-card--full-width .ace-betting-promo-card__actions {
    display: flex;
    margin-top: var(--ace-primitive-spacing-normal);
  }
}
.ace-betting-promo-card--condensed {
  align-items: center;
  flex-direction: row;
  gap: var(--ace-primitive-spacing-tight);
}
.ace-betting-promo-card--condensed .ace-betting-promo-card__condensed-content {
  align-items: center;
  display: flex;
  flex: 1;
  gap: var(--ace-primitive-spacing-tight);
  overflow: hidden;
  padding: var(--ace-primitive-spacing-tight);
  padding-right: var(--ace-primitive-spacing-x-loose);
}
@media only screen and (min-width: 595px) {
  .ace-betting-promo-card--condensed .ace-betting-promo-card__condensed-content {
    display: block;
  }
}
.ace-betting-promo-card--condensed .ace-betting-promo-card__condensed-text {
  overflow: hidden;
}
.ace-betting-promo-card--condensed .ace-betting-promo-card__image-container {
  aspect-ratio: 1/1;
  border-radius: var(--ace-primitive-radius-x-small);
  height: 3rem;
  width: 3rem;
}
@media only screen and (min-width: 595px) {
  .ace-betting-promo-card--condensed .ace-betting-promo-card__image-container {
    margin-bottom: var(--ace-primitive-spacing-normal);
  }
}
.ace-betting-promo-card--condensed .ace-betting-promo-card__headline {
  font-size: var(--ace-type-font-size-text-regular);
  letter-spacing: var(--ace-type-letter-spacing-text-regular);
  line-height: var(--ace-type-line-height-text-regular);
  font-family: var(--ace-type-font-family-interactive);
  font-weight: var(--ace-type-font-weight-interactive);
  text-decoration: none;
}
@media only screen and (min-width: 595px) {
  .ace-betting-promo-card--condensed .ace-betting-promo-card__actions {
    align-items: center;
    background: var(--ace-color-surface-solid--100);
    border-radius: var(--ace-primitive-radius-small);
    column-gap: var(--ace-primitive-spacing-x-tight);
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    margin: var(--ace-primitive-spacing-x-tight);
    padding: var(--ace-primitive-spacing-x-tight);
    row-gap: var(--ace-primitive-spacing-x-tight);
  }
  .ace-betting-promo-card--condensed .ace-betting-promo-card__actions > ::slotted(*) {
    width: calc((100% - 1 * var(--ace-primitive-spacing-x-tight)) / 2);
  }
}